module.exports = __webpack_public_path__ + "img/cart.a2c1beb0.png";